import * as v from 'valibot';

import type { PathLabel } from '../types';

export const pathLabelSchema: v.GenericSchema<PathLabel> = v.object({
  id: v.string('Path label ID is missing'),
  name: v.string('Path label name is missing'),
  startPoint: v.number('Path label start point is missing'),
  isActive: v.boolean('Path label active status is missing'),
});
